/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);





